import { Capacitor } from '@capacitor/core';

/**
 * Composable for CapacitorJS platform detection and utilities
 */
export function useCapacitor() {
  const isNative = Capacitor.isNativePlatform();
  const platform = Capacitor.getPlatform(); // 'ios' | 'android' | 'web'
  const isIOS = platform === 'ios';
  const isAndroid = platform === 'android';
  const isWeb = platform === 'web';

  return {
    isNative,
    platform,
    isIOS,
    isAndroid,
    isWeb,
    Capacitor
  };
}
